import { useEffect, useLayoutEffect } from 'react'

/**
 * useLayoutEffect in the browser, so a state it sets is drawn before the
 * browser paints; useEffect on the server, where a layout effect only warns
 * (neither runs there)
 */
export const useIsomorphicLayoutEffect =
  typeof window === 'undefined' ? useEffect : useLayoutEffect
